import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionMarkCircleIcon } from '@heroicons/react/outline';
import { apiCurrentUserHelpdeskContent } from '../../../common/api/currentUser';
import settings from '../../../common/settings';
import useList from '../../../utils/useList';
import NavigationItem from '../NavigationItem';
import NavigationHelpdeskModal from './NavigationHelpdeskModal';

const {
  helpdeskLink = 'https://theclinician.atlassian.net/servicedesk/customer/portal/3',
} = settings.public;

const NavigationHelpdesk = ({ isOpen }) => {
  const { t } = useTranslation();

  const { ready, items } = useList(
    apiCurrentUserHelpdeskContent.withParams({
      resultId: '$meta.id',
    }),
  );

  const hasHelpdeskContent = ready && !isEmpty(items);

  return hasHelpdeskContent ? (
    <NavigationHelpdeskModal items={items} isOpen={isOpen} />
  ) : (
    <NavigationItem
      testId="menu-item-helpdesk"
      label={t('helpdesk')}
      icon={<QuestionMarkCircleIcon className="flex-shrink-0" />}
      href={helpdeskLink}
      isOpen={isOpen}
    />
  );
};

NavigationHelpdesk.propTypes = {
  isOpen: PropTypes.bool,
};

NavigationHelpdesk.defaultProps = {
  isOpen: false,
};

export default NavigationHelpdesk;
